var _defs, _path, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 918.47 96.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-family: Copperplate-Bold, Copperplate;\n        font-size: 90.73px;\n        font-weight: 700;\n        letter-spacing: -.06em;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73,5.74h85.16c2.61,0,4.73,2.12,4.73,4.73v75.7c0,2.61-2.12,4.73-4.73,4.73H4.73c-2.61,0-4.73-2.12-4.73-4.73V10.47c0-2.61,2.12-4.73,4.73-4.73ZM60.53,37.87l-11.59,11.59-10.03-10.04-20.07,20.07,6.69,6.69,13.38-13.38,10.03,10.03,18.28-18.28,8.48,8.48v-23.66h-23.66l8.48,8.48Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(107.95 70.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OMINI CHIT FUNDS"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e71135b4765b88a574b7517d3e322dbe.svg";
export { ForwardRef as ReactComponent };